/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Banner_TitleInputs */



/**
* | output |
* | --- |
* | "An in-person conversation?" |
*
* @param {Meeting_Offline_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_banner_title = /** @type {((inputs?: Meeting_Offline_Banner_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Banner_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Fysiek gesprek?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une conversation en présentiel ?")
	return /** @type {LocalizedString} */ ("An in-person conversation?")
});